exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-50320e08] .el-collapse{border-top:0}", ""]);

// exports
